// extracted by mini-css-extract-plugin
module.exports = {"amz-activity":"AMZMemberDay_amz-activity__4eVm_"};